import type { ComponentSpecifications, TabSection } from './eto-app';
import CustomSelect from './custom-select';

function ComponentLevelSpecificationsSection({ componentName, componentsLoading, error, componentSpecifications, sectionTabs, sectionSelectors, setActiveSubsection, updateUrlHash, getComponentLabel, euImporterAddress, euRepresentativeAddress, i18n }: {
    componentName: string;
    componentsLoading: boolean;
    error: string | null;
    componentSpecifications: ComponentSpecifications | null;
    sectionTabs: TabSection[];
    sectionSelectors: Record<string, string>;
    setActiveSubsection: (tabName: string, subtabName: string | null, subsectionName: string) => void;
    updateUrlHash: () => void;
    getComponentLabel: (componentName: string) => string;
    euImporterAddress: string | null;
    euRepresentativeAddress: string | null;
    i18n: (key: string) => string;
}) {
    return (
        <>
            {componentsLoading &&
                <tbody>
                    {new Array(6).fill(0).map((_, index) => (
                        <tr key={index} className={`${componentName}__table-row ${componentName}__table-row-skeleton`}>
                            <th className={`${componentName}__table-cell-skeleton`}>
                                <div className={`${componentName}__table-cell-skeleton-content ${componentName}__loading-animation`}></div>
                            </th>
                            <td className={`${componentName}__table-cell-skeleton`}>
                                <div className={`${componentName}__table-cell-skeleton-content ${componentName}__loading-animation`}></div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            }
            {!componentsLoading && !error && componentSpecifications &&
                <>
                    {componentSpecifications.components.length > 0 && (
                        <div className={`${componentName}__spec-filter`}>
                            <CustomSelect
                                componentName={componentName}
                                className={`${componentName}__spec-filter-select`}
                                ariaLabel={i18n('Filter by component')}
                                value={sectionTabs.find((tab) => tab.name === sectionSelectors.technicalSpecifications)?.subtabs.find((subtab) => subtab.name === sectionSelectors.componentLevelSpecifications)?.activeSection || 'All'}
                                options={[
                                    { value: 'All', label: i18n('All Components') },
                                    ...componentSpecifications.components.map((component, index) => ({
                                        value: component.componentId,
                                        label: i18n('Component') + ' ' + (index + 1)
                                    })),
                                ]}
                                onChange={(value) => {
                                    setActiveSubsection(sectionSelectors.technicalSpecifications, sectionSelectors.componentLevelSpecifications, value);
                                    updateUrlHash();
                                }}
                                i18n={i18n}
                            />
                        </div>
                    )}
                    {componentSpecifications.components.map((component, index) => (
                        ((sectionTabs.find((tab) => tab.name === sectionSelectors.technicalSpecifications)?.subtabs.find((subtab) => subtab.name === sectionSelectors.componentLevelSpecifications)?.activeSection || 'All') === 'All' || (sectionTabs.find((tab) => tab.name === sectionSelectors.technicalSpecifications)?.subtabs.find((subtab) => subtab.name === sectionSelectors.componentLevelSpecifications)?.activeSection || 'All') === component.componentId) && (
                            <div key={component.componentId} className={`${componentName}__table-section`}>
                                <div className={`${componentName}__table-section-header`}>
                                    <span className={`${componentName}__table-section-name`}>{`${i18n('Component')} ${index + 1}`}</span>
                                    {component.componentName && <span className={`${componentName}__table-section-tag`}>{component.componentName}</span>}
                                </div>
                                <div className={`${componentName}__table-section-content`}>
                                    {component.sections.map((section) => (
                                        <div key={section.sectionName} className={`${componentName}__table-section-group`}>
                                            {(component.sections.length > 1 || section.sectionName !== i18n('Other')) && (
                                                <div className={`${componentName}__table-section-title`}>
                                                    {section.sectionName}
                                                </div>
                                            )}
                                            <table className={`${componentName}__table`}>
                                                <tbody>
                                                    {section.characteristics.map((characteristic) => (
                                                        <tr key={characteristic.name} className={`${componentName}__table-row`}>
                                                            <th className={`${componentName}__table-cell`}>{characteristic.name}</th>
                                                            <td className={`${componentName}__table-cell`}>{characteristic.value}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    ))}
                    {(euImporterAddress || euRepresentativeAddress) && (
                        <div className={`${componentName}__table-section`}>
                            <div className={`${componentName}__table-section-header`}>
                                <span className={`${componentName}__table-section-name`}>{i18n('Regulatory Information')}</span>
                            </div>
                            <table className={`${componentName}__table`}>
                                <tbody>
                                    {euImporterAddress && <tr className={`${componentName}__table-row`}>
                                        <th className={`${componentName}__table-cell`}>{i18n('EU Importer Address')}</th>
                                        <td className={`${componentName}__table-cell`} dangerouslySetInnerHTML={{ __html: euImporterAddress }}></td>
                                    </tr>}
                                    {euRepresentativeAddress && <tr className={`${componentName}__table-row`}>
                                        <th className={`${componentName}__table-cell`}>{i18n('EU Authorized Representative Address')}</th>
                                        <td className={`${componentName}__table-cell `} dangerouslySetInnerHTML={{ __html: euRepresentativeAddress }}></td>
                                    </tr>}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            }
        </>
    );
}

export default ComponentLevelSpecificationsSection;